<ras-page>
	<main>
		<h1>Secure self-storage</h1>

		<p class="lead">We offer peace of mind as we take comprehensive measures to maintain safe and secure self-storage facilities.</p>

		<nav>
			<ul>
				<li><a routerLink="./" fragment="high-security">High security</a></li>
				<li><a routerLink="./" fragment="electronic-systems-guarding">Electronic systems &amp; guarding</a></li>
				<li><a routerLink="./" fragment="access-storage-premises">Access to storage premises</a></li>
				<li><a routerLink="./" fragment="storage-unit-locking">Storage unit locking</a></li>
			</ul>
		</nav>


		<h2 id="high-security">High security</h2>

		<p>You will experience strict enforcement of access rules and procedures, with visible and concealed state-of-the-art systems and perimeter security at all our storage facilities. Consistently high standards are kept with constant monitoring, daily lock checks and system maintenance.</p>


		<h2 id="electronic-systems-guarding">Electronic systems &amp; guarding</h2>

		<p><strong>The following is in place:</strong></p>

		<ul>
			<li>A unique partnership with our security companies to ensure that our guards are, committed, and form an integral part of the Rent-A-Store team.</li>
			<li>Perimeters are protected by off site monitoring IP Cameras, walling, palisade fencing and full height electric fencing, maintained 24/7 and linked to armed response.</li>
			<li>Guarding with patrol monitoring and armed response back up.</li>
			<li>Strict access control procedures with identification systems and CCTV surveillance.</li>
			<li>Gates are locked at night, and premises are monitored off site.</li>
			<li>Daily walk through lock checks with individual unit over tagging.</li>
			<li>Ample night lighting for surveillance.</li>
			<li>Other special security procedures.</li>
		</ul>


		<h2 id="access-storage-premises">Access to storage premises</h2>

		<h3>Arrival</h3>

		<p>On arrival at RENT-A-STORE, you or your registered access person will be required to present certain information for verification.</p>
		<p>You or your access person will be required to produce valid identification on each entry.</p>
		<p>All particulars of your entry, time & movements while on site and your exit will be carefully monitored and recorded.</p>
		<p>Tenants and access persons who fail to comply with access procedures & rules will not be given access to the premises.</p>
		<p>It must be noted that RENT-A-STORE co-operates with both the South African police, SARS & customs officials.</p>

		<h3>After hours access</h3>

		<p>Our facilities are locked out at night 6pm to 6am, and the premises are monitored off site. For the protection of our customers goods, no after hour’s access exceptions are ever made.</p>

		<h3>Access for unregistered helpers</h3>

		<p>Unregistered helpers must be accompanied by a registered user at all times.</p>

		<h3>Deliveries and collections</h3>

		<p>Delivery and transport companies must be accompanied by a registered user at all times.</p>


		<h2 id="storage-unit-locking">Storage unit locking</h2>

		<h3>Storage locks</h3>

		<p>Each unit door is fitted with a unique tamper proof padbolt system. Tenants secure their unit with their own padlock and key.</p>

		<h3>Holding of unit keys</h3>

		<p>Rent-A-Store does not hold padlock keys for any tenants.</p>

		<h3>Lost keys</h3>

		<p>Lock cutting can only be arranged by Rent-A-Store for a small fee with written notice from the tenant.</p>
	</main>
</ras-page>